module.exports = __webpack_public_path__ + "static/img/company-12.c560f6c0.png";